/**
 * Template variables for labels and descriptions for the selected
 * data group
 * @example group: user|Account
 * @example groupTitle: User|Account
 * @example pluralGroup: users|Account(s)
 * @example pluralGroupTitle: Users|Account(s)
 */
export enum AggregationGroupLabel {
  Group = `group`,
  GroupTitle = `groupTitle`,
  PluralGroup = `pluralGroup`,
  PluralGroupTitle = `pluralGroupTitle`,
  MetricType = `metricType`,
}

export type AggregationLabelParams = {[key in AggregationGroupLabel]: string};

export type SelectorTypeAggregationLabel = string | ((params: AggregationLabelParams) => string);
